import {
  Logger
} from "./chunk-MG6YGXXR.mjs";

// src/react/datadog/index.ts
import { datadogLogs } from "@datadog/browser-logs";
var MAPS = {
  fatal: "critical",
  error: "error",
  info: "info"
};
var DatadogLogger = class {
  constructor(opts) {
    datadogLogs.init(opts);
    Logger.init(this);
  }
  get isInitialized() {
    return !!Logger.isInitialized;
  }
  captureException(exception, context) {
    datadogLogs.logger.error(
      (exception == null ? void 0 : exception.name) || exception.message,
      { ...context, status: this.getLevel(context == null ? void 0 : context.level) },
      exception
    );
    return void 0;
  }
  captureMessage(message, context) {
    datadogLogs.logger.info(message, { ...context, status: this.getLevel(context == null ? void 0 : context.level) });
    return void 0;
  }
  setUser(user) {
    datadogLogs.setUser({
      ...user,
      id: user._id
    });
  }
  lastId() {
    var _a;
    return (_a = datadogLogs.getInternalContext()) == null ? void 0 : _a.session_id;
  }
  showReportDialog(_opts) {
  }
  getLevel(level) {
    let _level = level;
    if (level) {
      _level = MAPS[level] || level;
    }
    return _level;
  }
};

export {
  DatadogLogger
};
//# sourceMappingURL=chunk-JEZ473CG.mjs.map